import React from "react";
import { Box, FormControl, InputLabel, Select } from "@mui/material";
import { CustomMenuItem, NoSuggestionsTextField } from "../../../../components/textFields";

function CreateCategory({ name, setName, description, setDescription, categoryType, setCategoryType, classification }) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <NoSuggestionsTextField
        required
        label="Nombre de la Categoría"
        value={name}
        onChange={(e) => setName(e.target.value)}
        fullWidth
      />
      <NoSuggestionsTextField
        required
        label="Descripción"
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        fullWidth
      />
      <FormControl fullWidth required margin="dense">
        <InputLabel id="category-type-label">Tipo de categoría</InputLabel>
        <Select
          labelId="category-type-label"
          value={categoryType}
          onChange={(e) => setCategoryType(e.target.value)}
          label="Tipo de categoría"
          sx={{
            backgroundColor: "#f9fafb",
            borderRadius: 2,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#d1d5db',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#a3a3a3',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#a3a3a3',
              borderWidth: 2,
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
              },
            },
          }}
        >
          {classification === "categories" && <CustomMenuItem value="categories">Productos</CustomMenuItem>}
          {classification === "background_images_categories" && <CustomMenuItem value="background_images_categories">Imágenes</CustomMenuItem>}
        </Select>
      </FormControl>
    </Box>
  );
}

export default CreateCategory;
